import { Box, FormControlLabel, Grid, Radio, RadioGroup } from '@deere/fuel-react';
import React, { useEffect, useState } from 'react'
import { getDataWAuth } from '../../utils/api-service';
import { APP_VIEW, LAST_FILE_UPLOAD } from '../../constants/constant';

const CustomCountrySelect = (props) => {
    const [lastUpdate, setLastUpdate] = useState({});

    const handleSelectedCountry = (event) => {
        if (props.selectedCountry) {
            props.selectedCountry(event.target.value);
        }
    };

    useEffect(() => {
        getDataWAuth(LAST_FILE_UPLOAD, { view: APP_VIEW.UPLOAD })
            .then((res) => {
                setLastUpdate(res.data);
            }).catch((error) => {
                console.log("Error getting last update : ", error);
            })
    }, [])


    return (
        <div>
            <Grid container>
                <Grid
                    item
                    sm={6}
                    xs={12}
                >
                    <Box p={4}>
                        <strong>
                            Country
                        </strong>
                        <RadioGroup name="countryGroup">
                            {/* <FormControlLabel
                                control={<Radio />}
                                label="Germany"
                                value={"DE"}
                                onChange={handleSelectedCountry}
                            /> */}
                            <FormControlLabel
                                control={<Radio />}
                                label="France"
                                value={"FR"}
                                onChange={handleSelectedCountry}
                            />
                             {/* <FormControlLabel
                                control={<Radio />}
                                label="United Kingdom"
                                value={"UK"}
                                onChange={handleSelectedCountry}
                            /> */}
                        </RadioGroup>
                    </Box>
                </Grid>
                <Grid
                    item
                    sm={6}
                    xs={12}
                >
                    <Box p={4}>
                        <strong>
                            Last Upload
                        </strong>
                        
                        {/* <div style={{ marginBottom: '10px' }}>
                            {Array.isArray(lastUpdate) && lastUpdate.find((item) => item.country === 'DE')?.updatedDateTime}
                        </div> */}
                        <div style={{ marginBottom: '10px' }}>
                            {Array.isArray(lastUpdate) && lastUpdate.find((item) => item.country === 'FR')?.updatedDateTime}
                        </div>
                        {/* <div style={{ marginBottom: '10px' }}>
                            {Array.isArray(lastUpdate) && lastUpdate.find((item) => item.country === 'GB')?.updatedDateTime}
                        </div> */}
                    </Box>
                </Grid>
            </Grid>
        </div>
    )
}

export default CustomCountrySelect;